import { createContext, useContext } from "react";

import type { UserGuideImage } from "../../entities/user-guide";

/**
 * Что дереву блоков нужно от страницы: адреса картинок, открытие окна просмотра
 * и переход к разделу. Через контекст, а не через свойства: блоки вложены друг в
 * друга на любую глубину, и тащить это через каждый уровень незачем.
 */
export interface GuideContextValue {
  readonly images: Readonly<Record<string, UserGuideImage>>;
  readonly openImage: (imageId: string) => void;
  /** Картинка не загрузилась — скорее всего, истекла подписанная ссылка. */
  readonly imageFailed: () => void;
  readonly goToSection: (id: string) => void;
}

export const GuideContext = createContext<GuideContextValue | null>(null);

export function useGuide(): GuideContextValue {
  const value = useContext(GuideContext);
  if (value === null) {
    throw new Error("GuideContext is missing: render blocks inside GuidePage.");
  }
  return value;
}
